<!-- eslint-disable -->
<template lang="pug">
    .school-form__container
        .school-form
            .school-form__title
                slot(name="title")
            form.school-form__body(
                v-if="school.status === 'active'"
                action="javascript://"
                @submit="submitForm"
            )
                .school-form__field
                    .school-form__label
                        | {{ $i18n.t('school.school_form_name') }}
                    .school-form__field-body
                        cs-input.school-form__input(
                            :error="errors.has('name')"
                            type="text"
                            v-model="schoolCopy.name"
                            name="name"
                            v-validate="'required'"
                            :data-vv-as="$i18n.t('school.school_form_name').toLowerCase()"
                        )
                        help-text(v-if="errors.has('name')" :error="errors.has('name')")
                            | {{ errors.first('name')}}
                .school-form__field
                    .school-form__label
                        | {{ $i18n.t('school.school_form_language') }}
                    .school-form__field-body
                        cs-multiselect(
                            :multiple="false"
                            :options="locales"
                            :show-labels="false"
                            :allow-empty="false"
                            :custom-label="getLocaleName"
                            placeholder=""
                            v-model="schoolCopy.locale"
                            :searchable="false"
                            v-validate="'required'"
                            name="locale"
                            :data-vv-as="$i18n.t('school.school_form_language').toLowerCase()"
                        )
                        help-text(v-if="errors.has('locale')" :error="errors.has('locale')")
                            | {{ errors.first('locale')}}
                divider
                .school-form__field
                    .school-form__label
                        | E-mail
                    .school-form__field-body
                        cs-input.school-form__input(
                            type="email"
                            v-model="schoolCopy.email"
                        )
                .school-form__field
                    .school-form__label
                        | {{ $i18n.t('school.school_form_phoneNumber') }}
                    .school-form__field-body
                        cs-input.school-form__input(
                            type="tel"
                            v-model="schoolCopy.phone"
                        )
                divider
                .school-form__field
                    .school-form__label.school-form__label--image
                        | {{ $i18n.t('school.school_form_image') }}
                    .school-form__field-body
                        cs-image-input(
                            v-model="schoolCopy.avatar"
                            @showSizeError="showSizeError"
                            type="school"
                            :loadText="$i18n.t('profiles.profiles_common_uploadImage')"
                            :removeText="$i18n.t('profiles.profiles_common_removeImage')"
                            :helpText="$i18n.t('common.common_imageInput_sizeHelpText')"
                            :error="showImageWarning ? imageWarningText : ''"
                        )
                template
                    divider
                    .school-form__field
                        .school-form__label
                            | {{ $i18n.t('school.school_form_availableCourses') }}
                        .school-form__field-body
                            cs-multiselect(
                                :options="courses"
                                :show-labels="false"
                                :allow-empty="true"
                                :hide-selected="true"
                                :placeholder="$i18n.t('school.school_form_availableCoursesPlaceholder')"
                                label="name"
                                track-by="id"
                                :multiple="true"
                                :max="2"
                                :searchable="true"
                                :clear-on-select="false"
                                :loading="loadingCourses"
                                @open="getCourses"
                                v-model="schoolCopy.courses"
                                v-validate="'required'"
                                data-vv-value-path="innerValue"
                                data-vv-name="course"
                                :data-vv-as="$i18n.t('fields.fields_course').toLowerCase()"
                                class="multiple-multiselect"
                            )
                                span(slot="noResult")
                                    | {{ $i18n.t('fields.fields_courseNotFound') }}
                            help-text(v-if="errors.has('course')" :error="errors.has('course')")
                                | {{ errors.first('course')}}
                divider
                .school-form__field
                    .school-form__label
                    .school-form__field-body.school-form__field-body--bold
                        | {{ $i18n.t('school.school_form_mainLocation') }}

                template(v-for="(location, index) in schoolCopy.locations")
                    .school-form__field(v-if="index > 0")
                        .school-form__label
                        .school-form__field-body.school-form__field-body--bold
                            | {{ $i18n.t('school.school_form_branch') }} {{ index }}
                            a.school-form__link--close(
                                href="javascript://"
                                :title="$i18n.t('school.school_form_deleteBranch')"
                                @click="removeLocation(index)"
                            )
                                svg-icon(name="times", size="base")
                    .school-form__field
                        .school-form__label
                            | {{ $i18n.t('user.user_form_city') }}
                        .school-form__field-body
                            cs-input.school-form__input(
                                :error="errors.has('city' + index)"
                                type="text"
                                v-model="location.city"
                                :name="'city' + index"
                                v-validate="'required'"
                                :data-vv-as="$i18n.t('school.school_form_city').toLowerCase()"
                            )
                            help-text(v-if="errors.has('city' + index)" :error="errors.has('city' + index)")
                                | {{ errors.first('city' + index)}}
                    .school-form__field
                        .school-form__label
                            | {{ $i18n.t('user.user_form_address') }}
                        .school-form__field-body
                            cs-input.school-form__input(
                                :error="errors.has('address' + index)"
                                type="text"
                                v-model="location.address"
                                :name="'address' + index"
                                v-validate="'required'"
                                :data-vv-as="$i18n.t('school.school_form_address').toLowerCase()"
                            )
                            help-text(v-if="errors.has('address' + index)" :error="errors.has('address' + index)")
                                | {{ errors.first('address' + index)}}
                .school-form__field
                    .school-form__label
                    .school-form__field-body
                        a.school-form__link(href="javascript://" @click="addLocation")
                            | {{ $i18n.t('school.school_form_addBranch') }}
                .school-form__buttons
                    cs-button.school-form__button(
                        color="blue"
                        pattern="primary-outline"
                        @click.prevent="$router.back()"
                    )
                        | {{ $i18n.t('common.common_button_cancel') }}
                    cs-button.school-form__button(
                        color="blue"
                        type="submit"
                        :loading="isLoading"
                    )
                        slot(name="button")
</template>

<script>
    /*eslint-disable*/
    import _, {camelCase, uniqBy} from 'lodash';
    import UserApi from '../../api/user/user';
    import CourseApi from '../../api/course';
    import {mapState} from 'vuex';
    import PaymentServicesApi from '../../api/billing/paymentServices'
    import availableLocales from "../../config/availableLocales";

    const MENTAL_TYPE = 'mental-arithmetic';

    const MENTAL_IDS = [2, 3, 4, 5, 6, 7, 8, 19];

    export default {
        data () {
            return {
                schoolCopy: Object,
                statuses: [
                    'active',
                    'archived'
                ],
                statusNames: {
                    active: this.$i18n.t('common.common_status_active'),
                    archived: this.$i18n.t('common.common_status_archived')
                },
                paymentServices: [],
                mainContacts: [],
                courses: [],
                isLoading: false,
                loadingContacts: false,
                loadingCourses: false,
                loadingPaymentServices: false,
                image: null,
                displayCropImageModal: false,
                showImageWarning: false,
                imageWarningText: '',
                locales: availableLocales.locales,
                localeNames: availableLocales.localeNames,
                existingCourses: ['mentalArithmetic', 'fastReading', 'onlineSchool', 'mathMagic', 'memoryDevelopment', 'multiplication', 'readingEn', 'russianLanguage'],
            }
        },
        created () {
            this.schoolCopy = _.cloneDeep(this.school);

            if (this.schoolCopy.account) {
                this.schoolCopy.mentalArithmeticMinPayment = this.schoolCopy.account.mentalArithmeticMinPayment;
                this.schoolCopy.fastReadingMinPayment = this.schoolCopy.account.fastReadingMinPayment;
                this.schoolCopy.onlineSchoolMinPayment = this.schoolCopy.account.onlineSchoolMinPayment;
                this.schoolCopy.mathMagicMinPayment = this.schoolCopy.account.mathMagicMinPayment;
                this.schoolCopy.memoryDevelopmentMinPayment = this.schoolCopy.account.memoryDevelopmentMinPayment;
                this.schoolCopy.multiplicationMinPayment = this.schoolCopy.account.multiplicationMinPayment;
                this.schoolCopy.readingEnMinPayment = this.schoolCopy.account.readingEnMinPayment;
                this.schoolCopy.russianLanguageMinPayment = this.schoolCopy.account.russianLanguageMinPayment;
            }
            if (this.schoolCopy.mainContact) {
                this.schoolCopy.mainContact.fullName =
                        `${this.schoolCopy.mainContact.firstName} ${this.schoolCopy.mainContact.lastName}`;
            }
        },
        props: {
            school: Object,
            submit: Function
        },
        watch: {
            'schoolCopy.avatar': {
                handler (val) {
                    if (val) {
                        this.showImageWarning = false;
                        this.imageWarningText = '';
                    }
                }
            },
            'schoolCopy.isBillingAvailable' (value) {
                if (!value) {
                    this.schoolCopy.mentalArithmeticMinPayment = undefined;
                    this.schoolCopy.fastReadingMinPayment = undefined;
                    this.schoolCopy.onlineSchoolMinPayment = undefined;
                    this.schoolCopy.mathMagicMinPayment = undefined;
                    this.schoolCopy.memoryDevelopmentMinPayment = undefined;
                    this.schoolCopy.multiplicationMinPayment = undefined;
                    this.schoolCopy.readingEnMinPayment = undefined;
                    this.schoolCopy.russianLanguageMinPayment = undefined;
                }
            }
        },
        methods: {
            addLocation() {
                this.schoolCopy.locations.push({
                    city: '',
                    address: '',
                    isMain: false
                })
            },
            removeLocation(index) {
                this.schoolCopy.locations.splice(index, 1);
            },
            submitForm() {
                console.log(this.schoolCopy.courses);
                if (this.schoolCopy.courses.length > 2) {
                    this.$toasted.error(this.$i18n.t('common.common_courses_limit'));
                    return;
                }
                this.$validator.validateAll()
                .then(isPassedValidation => {
                    if (isPassedValidation) {
                        this.isLoading = true;
                        this.submit(this.getOptimizedSchool())
                        .then((data) => {
                            this.isLoading = false;
                        })
                        .catch((err) => {
                            if (err.response.data.errors) {
                                let errors = err.response.data.errors;
                                for (let field in errors) {
                                    if (errors.hasOwnProperty(field)) {
                                        errors[field].forEach((val) => {
                                            this.errors.add(field, val);
                                        });
                                    }
                                }
                            }
                            this.isLoading = false;
                        });
                    }
                })
                .catch(() => {
                    this.$toasted.error(this.$i18n.t('errors.fill_form'));
                })
                .finally(() => {
                    this.isLoading = false;
                })
            },
            getCourses() {
                if (this.courses.length) return;
                this.loadingCourses = true;
                CourseApi.getCoursesForTariff()
                    .then(data => {
                        const nonMental = Object.values(data).filter(c => c.type !== MENTAL_TYPE && c.id !== 16);
                        nonMental.push({
                            id: '__MENTAL__',
                            name: 'Ментальная арифметика',
                            type: MENTAL_TYPE
                        });
                        this.courses = nonMental;
                        this.loadingCourses = false;
                        this.coursesLoaded = true;
                    })
                    .catch((e) => {
                        console.log(e)
                        this.loadingCourses = false;
                        this.$toasted.error(this.$i18n.t('errors.error_has_occurred'));
                    });
            },
            getLocaleName(locale) {
                return this.localeNames[locale];
            },
            showSizeError () {
                this.imageWarningText = this.$i18n.t('trainer.trainer_gameFormSetting_imageWeightWarning');
                this.showImageWarning = true;
            },
            getOptimizedSchool () {
                let form = _.cloneDeep(this.schoolCopy);
                form.isBillingActive = true;
                form.isTeachersBillingActive = true;
                if (form.account && form.account.paymentService) {
                    form.paymentServiceId = form.account.paymentService.id;
                }
                form.mainContactId = form.mainContact.id;
                form.coursesIds = this.getCoursesIds(form.courses);
                form.adminsIds = form.admins.map(admin => admin.id);
                delete form.account;
                delete form.mainContact;
                delete form.courses;
                delete form.students;
                delete form.teachers;
                delete form.admins;
                delete form.grades;
                delete form.allStudents;
                delete form.amountOfStudents;
                delete form.createdAt;
                delete form.updatedAt;
                return form;
            },
            getCoursesIds(courses) {
                const hasMental = courses.some(c => c.type === MENTAL_TYPE);

                const ids = courses
                    .filter(c => c.type !== MENTAL_TYPE)
                    .map(c => c.id);

                if (hasMental) ids.push(...MENTAL_IDS);

                return Array.from(new Set(ids));
            }
        },
        computed: {
            ...mapState({
                user: state => state.auth.user
            }),
        },
    }
</script>

<style lang="scss" scoped>
    .school-form__container {
        margin: 0;
        height: 100%;
        background-color: $x-color-white;
        border-radius: $border-radius-20;
        box-sizing: border-box;
        @include media($md) {
            padding: 30px;
        }
    }

    .school-form {
        margin: 0;
        padding: 30px 20px;
        height: 100%;
        background-color: $hsl-color-gray-98;
        border-radius: $border-radius-20;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        flex-direction: column;
        @include media($md) {
            padding: 30px;
        }
    }

    .school-form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        margin-bottom: 25px;
    }

    .school-form__body {
        width: 100%;
        box-sizing: border-box;
        @include media($lg) {
            padding: 0 4.5%;
        }
    }

    .school-form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }

    .school-form__input {
        margin-bottom: 0;
        &::-webkit-inner-spin-button,
        &::-webkit-outer-spin-button{
            appearance: none;
            margin: 0;
        }
    }

    .school-form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: .5rem;
        @include media($md) {
            width: 8em;
            min-width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            width: 13em;
            min-width: 13em;
        }
    }

    .school-form__label--image {
        @include media($md) {
            padding-top: 2.5em;
        }
    }

    .school-form__field-body {
        flex-grow: 5;
    }

    .school-form__field-body--bold {
        font-weight: 500;
        display: flex;
        align-items: center;
    }

    .school-form__buttons {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
        }
    }

    .school-form__button {
        margin: 10px 50px;
        @include media($md) {
            margin: 0 10px;
        }
    }

    .school-form__link {
        color: $hsl-color-blue-56;
        text-decoration: underline;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }

    .school-form__link--close {
        margin-left: 10px;
        color: $hsl-color-blue-56;
        &:hover {
            color: $hsl-color-red-62;
        }
    }
</style>
